const BaseComponent = require('base/base-component');
const Server = require('helper/server');

const listTpl = Handlebars.templates['common/home/templates/panel'];

module.exports = class extends BaseComponent {
  init () {
    this.$supplierList = this.$el.find('.supplier-list');
    this.href = this.$el.find('.card__link').attr('href');
    this.detailPage = this.href.indexOf('index.html') > -1 ?
      this.href.replace('index.html', 'detail.html') : // 静态化之后
      '/org_detail'; // 静态化之前
    this.fetchData();
  }

  fetchData () {
    Server.getCMSData('supplierCount').then((resp) => {
      const data = typeof resp == 'string' ? JSON.parse(resp) : resp;
      const { publicCount, registerCount, tempCount, waitAuditCount } = data.result;
      const totoal = publicCount + registerCount + tempCount + waitAuditCount;
      const counts = [registerCount, publicCount, waitAuditCount];
      counts.map((value, index) => {
        this.$el
          .find('.progress-bar')
          .eq(index)
          .css('width', `${(value * 100) / totoal}%`);
        this.$el
          .find('.progress-count')
          .eq(index)
          .text(value);
      });
    });
    Server.getCMSData('officialSupplierIndexInfo').then((resp) => {
      const data = typeof resp == 'string' ? JSON.parse(resp) : resp;
      const formattedData = data.result.map(value => ({
        fullName: value.name,
        url: `${this.detailPage}?supplierId=${value.supplierId}`
      }));
      this.$supplierList.append(listTpl({ data: formattedData, active: true }));
      Server.getCMSData('publicSupplierIndexInfo').then((resp2) => {
        const data2 = typeof resp2 == 'string' ? JSON.parse(resp2) : resp2;
        const formattedData2 = data2.result.map(value => ({
          fullName: value.name,
          url: `${this.detailPage}?supplierId=${value.supplierId}`
        }));

        this.$supplierList.append(listTpl({ data: formattedData2 }));
      });
    });
  }
};
